import { atom } from "recoil";
import { CounterpartyRole, FlexFormStatus } from "../models/generated/graphql";

export const pageSizeOptions = [25, 50, 100, 250];
type ActivePageType = "cases.activePage";
type RowsPerPageType = "cases.rowsPerPage";

type ActivePage = {
	key: ActivePageType;
	default: number;
};

type RowsPerPage = {
	key: RowsPerPageType;
	default: number;
};
export interface ICaseFormDrawer {
	id: string;
	type: string;
	status: FlexFormStatus;
}

export interface IRightDrawerState {
	key: "cases.forms.rightDrawer";
	default: false | ICaseFormDrawer;
}

interface OrganizationRole {
	key: "organizationRole";
	default: CounterpartyRole | "payable";
}

const initialValueCasesActivePage: ActivePage = {
	key: "cases.activePage",
	default: 0,
};

const initialCasesRowsPerPage: RowsPerPage = {
	key: "cases.rowsPerPage",
	default: pageSizeOptions[3],
};

const agreementOrganizationRole: OrganizationRole = {
	key: "organizationRole",
	default: "payable",
};

export const casesActivePage = atom(initialValueCasesActivePage);
export const casesRowsPerPage = atom(initialCasesRowsPerPage);
export const caseAgreementOrganizationRole = atom(agreementOrganizationRole);
